module.exports = __webpack_public_path__ + "static/cusociety-logo-f3bb893ce21f60b6201209090eb88a18.png";